import type { CSSProperties, HTMLAttributes, ReactNode } from 'react'

import { cn } from '#utils'
import { gradientVariants, type GradientVariant } from '../GradientOverlay/'

type GradientDirection =
  | 'right'
  | 'left'
  | 'top'
  | 'bottom'
  | 'top-right'
  | 'top-left'
  | 'bottom-right'
  | 'bottom-left'

export type GradientCircleProps = {
  className?: string
  variant: GradientVariant
  text?: string
  textClassName?: string
  to?: GradientDirection
  border?: string
  children?: ReactNode
} & HTMLAttributes<HTMLDivElement>

const gradientDirectionCss: Record<GradientDirection, string> = {
  right: 'to right',
  left: 'to left',
  top: 'to top',
  bottom: 'to bottom',
  'top-right': 'to top right',
  'top-left': 'to top left',
  'bottom-right': 'to bottom right',
  'bottom-left': 'to bottom left',
}

export function GradientCircle({
  variant,
  text,
  textClassName,
  to = 'bottom-right',
  border,
  className,
  style,
  children,
  ...props
}: GradientCircleProps) {
  const gradient = gradientVariants[variant]

  const computedStyle: CSSProperties = {
    backgroundColor: gradient.color1,
    backgroundImage: `linear-gradient(${gradientDirectionCss[to]}, ${gradient.color1}, ${gradient.color2})`,
  }

  return (
    <div
      data-attribute="GradientCircle"
      {...props}
      className={cn(
        'rounded-full flex items-center justify-center shrink-0',
        className,
        border && `border ${border}`,
      )}
      style={{
        ...computedStyle,
        ...style,
      }}
    >
      {text ? <span className={cn('font-medium text-white', textClassName)}>{text}</span> : children}
    </div>
  )
}
